// Shared PaySimple workspace section nav — Dashboard / Subscriptions / Tx Reconciliation on the new
// "-new" routes. PaySimple's "schedules" are relabeled Subscriptions per the vocabulary rule.
// Single-account PSP, so no ?acct is carried.
import React from 'react';
import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import SubscriptionsIcon from '@mui/icons-material/Autorenew';
import ReconcileIcon from '@mui/icons-material/FactCheck';

export const PAYSIMPLE_NAV_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: <DashboardIcon fontSize="small" />, path: '/payments/paysimple' },
  { key: 'subscriptions', label: 'Subscriptions', icon: <SubscriptionsIcon fontSize="small" />, path: '/payments/paysimple/subscriptions' },
  { key: 'reconciliation', label: 'Tx Reconciliation', icon: <ReconcileIcon fontSize="small" />, path: '/payments/paysimple/reconciliation' },
];

export const buildPaysimpleNav = (active, navigate) => ({
  active,
  items: PAYSIMPLE_NAV_ITEMS,
  onNav: (key) => { const it = PAYSIMPLE_NAV_ITEMS.find((x) => x.key === key); if (it) navigate(it.path); },
});
